import script from "./CardItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardItem.vue?vue&type=script&setup=true&lang=ts"

import "./CardItem.vue?vue&type=style&index=0&id=0348b168&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/livoapp/LivoFrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0348b168"]])

export default __exports__